<template>
  <PTransparentLoader :loading="loading" class="event-wizard">
    <h1 class="main-header mb-1">Overview</h1>
    <p v-translate translate-context="event_wizard.overview">Event overview: key data, actions and notes</p>
    <template v-if="isDraft">
      Publish your event to see the overview
    </template>
    <template v-else>
      <Stats/>
      <MediaKit :media-kit="data"/>
    </template>
    <CRow>
      <CCol xl="6" v-if="hasPerm('dashboard.view_feature_operation_log')">
        <EventNote />
      </CCol>
    </CRow>

  </PTransparentLoader>
</template>

<script>

import PTransparentLoader from "@/domain/core/components/PTransparentLoader.vue";
import EventNote from "@/domain/eventWizard/components/overview/EventNote.vue";
import {mapGetters} from "vuex";
import MediaKit from "@/domain/eventWizard/components/overview/MediaKit.vue";
import Stats from "@/domain/eventWizard/components/overview/Stats.vue";

export default {
  name: "StepOverview",
  components: {Stats, MediaKit, EventNote, PTransparentLoader},
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapGetters('event', [
      'isDraft'
    ]),
  },
}
</script>
